import { render, staticRenderFns } from "./addDataFilters.vue?vue&type=template&id=715f71c1"
import script from "./addDataFilters.vue?vue&type=script&lang=js"
export * from "./addDataFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports